export const TABLE_COMPANY_INDEX = {
  CompanyID: "coid",
  Status: "status",
  ReqStatus: "isBlocked",
  Name: "name",
  ShortCode : "short_code",
  SecDeposit: "secDeposit",
  Limit: "limit",
  LimitStatus: "limitStatus",
  CreatedAt: "createdAt",
  UpdatedAt: "updatedAt",
  Remarks: "remark",
  GlCode: "glcode",
  Privilege: "privilege",
  LoyaltyProgram: "loyaltyName",
  BillingDate: "billing_date",
  Period: "billing_period",
  PIC: "picName",
};

export const TABLE_COMPANY_TITLE = {
  CompanyID: "Company ID",
  Status: "Status",
  ReqStatus: "Request Status",
  Name: "Company Name",
  ShortCode: "Short Code",
  Regis_Number: "Company Registration Number",
  SecDeposit: "Security Deposit",
  payrollOnHold: "On Hold Request",
  Limit: "Company Limits",
  LimitStatus: "Company Limit Status",
  CreatedAt: "Created By",
  UpdatedAt: "Last Updated By",
  Remarks: "Remarks",
  TotalEmployer: "Total Employers",
  TotalEmployee: "Total Employees",
  GlCode: "GL Code",
  Privilege: "Privilege",
  LoyaltyProgram: "Loyalty Program",
  BillingDate: "Payroll Processing Date",
  Period: "Period",
  PIC: "PIC Info",
  PIC_Name: "PIC Name",
  PIC_Contact: "PIC Contact",
  TotalActiveEmployer: "Total Active Employers",
  TotalSuspendedEmployer: "Total Suspended Employers",
  TotalCreatedEmployee: "Total Created Employees",
  TotalActiveEmployee: "Total Active Employees",
  TotalSuspendedEmployee: "Total Suspended Employees",
};

export const COMPANY_STATUS = {
  active: 1,
  suspended: 2,
  terminated: 0,
};

export const BLOCK_STATUS = {
  enabled: 0,
  disabled: -1,
  suspend: 1,
};

export const COMPANY_STATUS_TITLE = {
  [COMPANY_STATUS.active]: {
    name: "Active",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 1,
  },
  [COMPANY_STATUS.suspended]: {
    name: "Suspended",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 2,
  },
  [COMPANY_STATUS.terminated]: {
    name: "Terminated",
    colorTag: "#FF0000",
    bgColor: "#FFF2F2",
    status: 0,
  },
};

export const BLOCK_STATUS_TITLE = {
  [BLOCK_STATUS.enabled]: {
    name: "Enable",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 0,
  },
  [BLOCK_STATUS.disabled]: {
    name: "Disabled",
    colorTag: "grey",
    bgColor: "#EDEDED",
    status: -1,
  },
  [BLOCK_STATUS.suspend]: {
    name: "Suspend",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 1,
  },
};

export const BLOCK_STATUS_OPTIONS = Object.values(BLOCK_STATUS).map((option) => ({
  label: BLOCK_STATUS_TITLE[option].name,
  value: option,
}));

export const EXPAND_TABLE_COMPANY_INDEX = {
  revisiion: "revision",
  limit: "limit",
  deposit_from: "deposit_from",
  deposit_adjustment: "deposit_adjustment",
  deposit_to: "deposit_to",
  deposit_receipt: "deposit_receipt",
  deposit_offer: "deposit_offer",
  updatedAt: "updatedAt",
  createdAt: "createdAt",
};

export const EXPAND_TABLE_COMPANY_TITLE = {
  revisiion: "Revision",
  limit: "Company Limits",
  company_limit: "Company Limits",
  deposit_from: "From Security Deposits",
  deposit_adjustment: "Security Deposits Adjustment",
  deposit_to: "To Security Deposits",
  deposit_receipt: "Deposit Receipt",
  deposit_offer: "Deposit Offer Letter",
  updatedAt: "Last Updated By",
  createdAt: "Created By",
};

export const TABLE_COMPANY_TITLE_BULK = {
  [TABLE_COMPANY_INDEX.Name]: "Employee Name",
  [TABLE_COMPANY_INDEX.IC]: "IC Number",
  [TABLE_COMPANY_INDEX.Amount]: "Eligible Amount",
  [TABLE_COMPANY_INDEX.Salary]: "Base Salary",
  [TABLE_COMPANY_INDEX.Position]: "Position",
  [TABLE_COMPANY_INDEX.Contact]: "Phone Number",
  [TABLE_COMPANY_INDEX.Bank_Name]: "Bank Name",
  [TABLE_COMPANY_INDEX.Bank_Acc]: "Bank Account",
};

export const TABLE_BULK_UPLOAD_INDEX = [
  [TABLE_COMPANY_INDEX.Name],
  [TABLE_COMPANY_INDEX.IC],
  [TABLE_COMPANY_INDEX.Position],
  [TABLE_COMPANY_INDEX.Contact],
  [TABLE_COMPANY_INDEX.Salary],
  [TABLE_COMPANY_INDEX.Amount],
  [TABLE_COMPANY_INDEX.Bank_Name],
  [TABLE_COMPANY_INDEX.Bank_Acc],
];

export const COMPANY_MANAGEMENT_TITLE_BY_NAME = Object.fromEntries(
  Object.keys(TABLE_COMPANY_TITLE_BULK).map((k) => [
    TABLE_COMPANY_TITLE_BULK[k],
    k,
  ])
);

const TABLE_BULK_UPLOAD_INDEX_OBJ_ENTRIES = Object.fromEntries(
  TABLE_BULK_UPLOAD_INDEX
);

export const TABLE_BULK_UPLOAD_INDEX_EMPTY_STRINGS = Object.fromEntries(
  Object.entries(TABLE_BULK_UPLOAD_INDEX_OBJ_ENTRIES).map(([key, value]) => [
    key,
    value || "",
  ])
);

export const COMPANY_INDEX = {
  name: "name",
  ic: "ic",
  position: "position",
  contact: "contact",
  baseSal: "baseSal",
  eligAmount: "eligAmount",
  bank_name: "bank_name",
  bank_acc: "bank_acc",
};

export const selectOptions = [
  { value: "createdAt", label: "Created Date", type: "date" },
  { value: "coid", label: "Company ID", type: "text" },
  { value: "name", label: "Company Name", type: "text" },
];
